import generateResumePath from '@glass/common/modules/resumes/paths/generateResumePath';
import { EXPERIENCES_FIELD_V2 } from '@glass/web/modules/resumes/fieldKeys';

export default generateResumePath(EXPERIENCES_FIELD_V2);
